import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef } from "vue";
import { useConfigurationTemplateUpgrade } from "@/components/ConfigTemplates/useConfigurationTesting";
import { useInstanceRouting } from "./routing";
import {} from "./types";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeForm',
    props: {
        instance: null,
        latestTemplate: null
    },
    setup(__props) {
        const props = __props;
        const editTestUrl = "/api/object_store_instances/{uuid}/test";
        const editUrl = "/api/object_store_instances/{uuid}";
        const title = computed(() => `Upgrade Object Store ${props.instance.name}`);
        const { error, ActionSummary, inputs, InstanceForm, loadingMessage, showForceActionButton, onForceSubmit, onSubmit, testRunning, testResults, submitTitle, } = useConfigurationTemplateUpgrade("storage location", toRef(props, "instance"), toRef(props, "latestTemplate"), editTestUrl, editUrl, useInstanceRouting);
        return { __sfc: true, editTestUrl, editUrl, props, title, error, ActionSummary, inputs, InstanceForm, loadingMessage, showForceActionButton, onForceSubmit, onSubmit, testRunning, testResults, submitTitle };
    }
});
